// removed by extract-text-webpack-plugin
module.exports = {"loader-outer":"style_loader-outer--2I3rTVyq","loaderOuter":"style_loader-outer--2I3rTVyq","centered":"style_centered--1tBsDRP9","loader-inner":"style_loader-inner--3bn_iPRz","loaderInner":"style_loader-inner--3bn_iPRz","circle":"style_circle--3cXm3u3E","dotloaderGreen":"style_dotloaderGreen--2FD7f9PG","dotloaderBlue":"style_dotloaderBlue--QSljVqXb"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/loading-dots/src/styles/style.scss
// module id = 1727
// module chunks = 0